<app-filter-panel [fields]="fieldsConfig" (search)="search()"></app-filter-panel>

<!--
<div class="grid">
    <div class="col-4 input-field p-input-icon-right">
        <input pInputText placeholder="Nombre" [(ngModel)]="filters.description.value" (keydown.enter)="search()"
            class="w-full" />
        <i *ngIf="filters.description.value" class="pi pi-times cursor-pointer"
            (click)="filters.description.value = null; search()"></i>
    </div>
    <div class="col-4 input-field">
        <p-dropdown placeholder="Usuario a filtrar" [options]="users" optionLabel="name" optionValue="id" (onFilter)="loadUsers($event)"
            [(ngModel)]="userSelectedId" (onChange)="search()" showClear [filter]="true" filterBy="name"
            [disabled]="!loginService.hasPermission('TASKS.VIEW_OTHER_USERS')" />
    </div>
    <div class="col-2 input-field">
        <p-dropdown placeholder="Estado" [options]="taskStatus" optionLabel="label" optionValue="value"
            [(ngModel)]="filters.isCompleted.value" (onChange)="search()" showClear />
    </div>
    <div class="col-2 input-field">
        <label for="incomingTasks">Mostras próximas tareas</label>
        <p-inputSwitch [(ngModel)]="incomingTasks" (onChange)="search()"></p-inputSwitch>
    </div>
</div>
-->

<p-table #grid [value]="tasks" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading"
    [paginator]="true" [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th pSortableColumn="description">Título <p-sortIcon field="description"></p-sortIcon></th>
            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
            <th pSortableColumn="user.name">Usuario asignado <p-sortIcon field="user.name"></p-sortIcon></th>
            <th pSortableColumn="createdByUser.name">Creado por <p-sortIcon field="createdByUser.name"></p-sortIcon>
            </th>
            <th pSortableColumn="isCompleted">Completado <p-sortIcon field="isCompleted"></p-sortIcon></th>
            <th width="100"></th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-task let-columns="columns">
        <tr (dblclick)="edit(task)">
            <td>
                <span class="p-badge p-badge-danger" *ngIf="task.isUrgent">!</span>
                {{task.description}}
            </td>
            <td [class.text-danger]="task.date.getTime() < today.getTime()" [class.text-warning]="task.date.getTime() == today.getTime()">
                <span [pTooltip]="(task.date | date: 'dd/MM/yyyy HH:mm')??''">{{task.date | date: 'dd/MM/yyyy'}}</span>
            </td>

            <td>
                <label  [ngClass]="{ 'text-red-500 ': task.user?.absence, '': !task.user?.absence }">{{task.user?.name}}</label>
            </td>
            <td>{{task.createdByUser?.name}}</td>
            <td>
                <i class="pi"
                    [ngClass]="{ 'text-green-500 pi-check-circle': task.isCompleted, 'text-red-500 pi-times-circle': !task.isCompleted }"></i>
            </td>
            <td>
                <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="delete(task)" [rounded]="true" [text]="false"
                        severity="danger"><i class="pi pi-trash"></i></p-button>
                    <p-button *ngIf="allowWrite" (click)="edit(task)" [rounded]="true" [text]="false"><i
                            class="pi pi-pencil"></i></p-button>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>